
                import { Component } from "/app/packages/open-source/blognami/lib/index.js";
                import { createDecoratorsInclude } from "/app/packages/open-source/blognami/lib/view_file_importers/js.js";
                import { decorators } from "/app/packages/open-source/@blognami/markdown/lib/views/_markdown_editor/modal.js";
                const hash = "ZLQWkNjhBz";
                Component.include(createDecoratorsInclude(hash, decorators));
            